module.exports = __webpack_public_path__ + "static/media/listing-page-koh-samui.c4388fa1.jpg";